export { default as withBoundingRects } from './enhancers/withBoundingRects';